/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferenceDataSyncItemsResponse } from './ReferenceDataSyncItemsResponse';
import {
    ReferenceDataSyncItemsResponseFromJSON,
    ReferenceDataSyncItemsResponseFromJSONTyped,
    ReferenceDataSyncItemsResponseToJSON,
    ReferenceDataSyncItemsResponseToJSONTyped,
} from './ReferenceDataSyncItemsResponse';

/**
 * 
 * @export
 * @interface ReferenceDataSyncResponse
 */
export interface ReferenceDataSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof ReferenceDataSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {ReferenceDataSyncItemsResponse}
     * @memberof ReferenceDataSyncResponse
     */
    syncItems?: ReferenceDataSyncItemsResponse;
}

/**
 * Check if a given object implements the ReferenceDataSyncResponse interface.
 */
export function instanceOfReferenceDataSyncResponse(value: object): value is ReferenceDataSyncResponse {
    return true;
}

export function ReferenceDataSyncResponseFromJSON(json: any): ReferenceDataSyncResponse {
    return ReferenceDataSyncResponseFromJSONTyped(json, false);
}

export function ReferenceDataSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferenceDataSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'syncItems': json['syncItems'] == null ? undefined : ReferenceDataSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function ReferenceDataSyncResponseToJSON(json: any): ReferenceDataSyncResponse {
    return ReferenceDataSyncResponseToJSONTyped(json, false);
}

export function ReferenceDataSyncResponseToJSONTyped(value?: ReferenceDataSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'syncItems': ReferenceDataSyncItemsResponseToJSON(value['syncItems']),
    };
}

